@if (summary$()) {
    <lib-trade-cost-analysis-summary
        class="overlay-override-container"
        [tradeCostAnalysisSummary$]="summary$()"
        [isLiveAnalysis$]="isLiveAnalysis$()" />
}
